export default __webpack_public_path__ + "static/media/InputIcon.e268b84b.svg";